import ThreadHeader from './ThreadHeader';
import ThreadHeaderContainer from './ThreadHeader.container';
export default ThreadHeaderContainer(ThreadHeader);

//# sourceMappingURL=index.js.map